import styled from 'styled-components'

import { Range } from 'components/Input/Range'

export const StyledRange = styled(Range)`
  margin: 0;
`
